module.exports = __webpack_public_path__ + "static/media/the-londoner-menu.1e4e9930.png";